import { DataUtils } from './dataUtils';

export { DataUtils };
export default DataUtils;